import { Component, Input } from '@angular/core';
import { DashboardWidgetLayout } from '../dashboard-grid/dashboard-grid';
@Component({selector:'app-dashboard-record-metric', standalone:false, templateUrl:'./dashboard-record-metric.html', styleUrl:'./dashboard-record-metric.scss'})
export class DashboardRecordMetric {
  /** Current canonical owner DTO projection, supplied only after authorised load. */
  @Input() iconSvg = '';
  @Input() value: number | null = null;
  @Input() label = '';
  @Input() description = '';
  @Input() layout: DashboardWidgetLayout = {xs:{width:4,height:1}};
  get displayed(): string { return this.value !== null && Number.isFinite(this.value) ? this.value.toLocaleString() : '—'; }
}
